/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { BgpNeighborCard, VpcCard, CloudContainer } from '../components/GraphNodes';
import { BgpNeighborData, BgpNeighborRoster, VpcData, CloudData } from '../BgpVisibilityData';

export const createNodeTypes = (
  onBgpNeighborClick: (data: BgpNeighborData) => void,
  onVpcClick: (data: VpcData) => void,
  onRouteTableClick: (routeTableData: any, vpcId: string) => void,
  isOutbound = false,
  neighborData: BgpNeighborRoster = {}
) => ({
  neighbor: (props: any) => {
    const neighborIp = props.data?.neighborIp;
    const neighborInfo = neighborIp ? neighborData[neighborIp] : undefined;
    return (
      <BgpNeighborCard
        {...props}
        onCardClick={onBgpNeighborClick}
        isOutbound={isOutbound}
        neighborInfo={neighborInfo}
      />
    );
  },
  vpc: (props: any) => (
    <VpcCard 
      {...props} 
      onCardClick={onVpcClick}
      onRouteTableClick={onRouteTableClick}
      isOutbound={isOutbound}
    />
  ),
  cloud: (props: any) => (
    <CloudContainer 
      data={props.data}
      isOutbound={isOutbound}
      onCardClick={(data: CloudData) => {
        if (data.vpcs.length > 0) {
          const firstVpc = data.vpcs[0];
          const routeTables = data.allData
            .filter((entry: any) => entry.vpc === firstVpc)
            .reduce((acc: any, entry: any) => {
              const key = isOutbound ? (entry.subnet_id || entry.route_table_id) : entry.route_table_id;
              const existing = acc.find((rt: any) => rt.route_table_id === key);
              if (existing) {
                existing.prefixes.push(entry);
              } else {
                acc.push({
                  route_table_id: key,
                  prefixes: [entry]
                });
              }
              return acc;
            }, []);
          onVpcClick({ vpcId: firstVpc, routeTables });
        }
      }}
      onVpcClick={onVpcClick}
      onRouteTableClick={onRouteTableClick}
    />
  ),
});

